<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import ExceptionsWorkspace from '@/components/shipment/exceptions/ExceptionsWorkspace.vue';
import { setTitle } from '@/utils/title';

const store = useStore();
const router = useRouter();

setTitle('Exceptions');

const accountId = computed(() => store.getters['auth/accountId'] as number);

function goToShipments() {
  void router.push({ name: 'ShipmentListView' });
}
</script>

<template>
  <div class="h-layout-mobile sm:h-layout-tablet md:h-layout-desktop flex">
    <ExceptionsWorkspace
      class="min-h-0 min-w-0 flex-1"
      :account-id="accountId"
      @switch-to-shipments="goToShipments"
    />
  </div>
</template>
